// Account type options for filtering
export const ACCOUNT_TYPE_OPTIONS = [
  { value: 'B', label: 'Balance' },
  { value: 'E', label: 'Expense' },
  { value: 'R', label: 'Revenue' },
  { value: 'S', label: 'Statistic' }
];

// Column definitions for filterable headers
// Note: accessor_key uses _search suffix to match API param naming convention
export const COLUMN_DEFINITIONS = {
  full_account: {
    accessor_key: 'full_account_search',
    database_column_name: 'full_account',
    display_name: 'Account Number',
    filter_type: 'basic',
    is_sortable: false
  },
  account_type: {
    accessor_key: 'account_type_search',
    database_column_name: 'account_type',
    display_name: 'Type',
    filter_type: 'multiselect',
    is_sortable: false
  },
  account_description: {
    accessor_key: 'account_description_search',
    database_column_name: 'account_description',
    display_name: 'Description',
    filter_type: 'basic',
    is_sortable: false
  }
};
